import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as parentStyles } from '../../gzEnumList/view/view.scss';

import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${commonStyles}`), unsafeCSS(`${parentStyles}`), unsafeCSS(`${componentStyles}`)];
